import Swiper from 'swiper';
import { Navigation, Autoplay, Grid } from 'swiper/modules';
import 'swiper/swiper.min.css';

// Wait for page load
$(window).on('load', () => {
    // Image slider
    if (document.querySelector('.image-slider')) {
        new Swiper(".image-slider", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: ".image-slider-button-next",
                prevEl: ".image-slider-button-prev",
            },
            loop: true
        });
    }

    // Logos slider
    const logosElement = document.querySelector('.logos-slider');
     if (logosElement) {
         // Shuffle logos before initializing the slider
         const wrapper = logosElement.querySelector('.swiper-wrapper');
         const slides = Array.from(wrapper.children);
         
         // Fisher-Yates shuffle algorithm
         for (let i = slides.length - 1; i > 0; i--) {
             const j = Math.floor(Math.random() * (i + 1));
             wrapper.appendChild(slides[j]);
         }
         
         // Initialize the logos slider
         new Swiper('.logos-slider', {
             modules: [Autoplay, Grid],
             loop: true,
             autoplay: {
                 delay: 1000,
                 disableOnInteraction: false
             },
             speed: 800,
             breakpoints: {
                 // Mobile view (2 rows of 3)
                 0: {
                     slidesPerView: 2,
                     slidesPerGroup: 2,
                     grid: {
                         rows: 3,
                         fill: 'row'
                     },
                     spaceBetween: 20
                 },
                 // Tablet and desktop view (single row of 6)
                 768: {
                     slidesPerView: 6,
                     slidesPerGroup: 1,
                     spaceBetween: 30,
                     grid: {
                         rows: 1
                     }
                 }
             }
         });
     }
});